export function isAuthenticated() {
  let secret = localStorage.getItem("userInfo");
  let user = localStorage.getItem("user");
  if (secret == null || secret.length === 0 || user == null) {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("user");
    return "/login";
  } else {
    return null;
  }
}

export const AuthMixin = {
  methods: {
    isAuthenticated,
  },
};



// WEBPACK FOOTER //
// ./src/router/authenticate.js